import React from 'react';

const AWS_Redshift = () => {
  return (
    <div>
      <h1>AWS_Redshift</h1>
      <p>This is the AWS_Redshift component.</p>
    </div>
  );
};

export default AWS_Redshift;
